export default __webpack_public_path__ + "static/media/event.8fe2b7fb.png";